import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSeamless'
})
export class FilterSeamlessPipe implements PipeTransform {

  transform(value: any[], ...args: string[]): any[] {
    if (!value.length) {
      return value;
    }

    const filtered = value.filter(v => v.getRawValue().game_type === args[0]);
    return filtered;
  }

}
